// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nx-0";